import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Settings = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [otp, setOtp] = useState("");
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [emailError, setEmailError] = useState("");

  // Validate email domain
  const validateEmail = (email) => {
    const domain = "@gxinetworks.com";
    if (email.endsWith(domain)) {
      setEmailError("");
      return true;
    } else {
      setEmailError(`Email must end with ${domain}`);
      toast.error(`Email must end with ${domain}`);
      return false;
    }
  };

  // Simulate sending OTP
  const sendOtp = () => {
    if (validateEmail(email)) {
      setIsOtpSent(true);
      toast.success("OTP has been sent to your email.");
    }
  };

  // Simulate verifying OTP
  const verifyOtp = () => {
    if (otp === "1234") {
      setIsOtpVerified(true);
      toast.success("OTP verified successfully.");
    } else {
      toast.error("Invalid OTP. Please try again.");
    }
  };

  // Simulate adding a new HR after OTP verification
  const addNewHR = () => {
    toast.success("HR added successfully with email: " + email);
  };

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <ToastContainer />
      <h1 className="text-2xl font-bold mb-6 hover:text-green-700">Settings</h1>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {/* HR Settings Section */}
        <div className="bg-white p-6 rounded-lg shadow-md">
          <h2 className="text-xl font-semibold mb-4">HR Settings</h2>
          <div className="space-y-4">
            {/* Profile Management */}
            <div>
              <label className="block font-medium mb-2">
                Profile Management
              </label>
              <input
                type="text"
                placeholder="Update HR profile"
                className="w-full border-gray-300 p-2 rounded-md"
              />
            </div>

            {/* Notification Preferences */}
            <div>
              <label className="block font-medium mb-2">
                Notification Preferences
              </label>
              <select className="w-full border-gray-300 p-2 rounded-md">
                <option>Email Notifications</option>
                <option>SMS Notifications</option>
                <option>Push Notifications</option>
              </select>
            </div>

            {/* Document Management */}
            <div>
              <label className="block font-medium mb-2">
                Document Management
              </label>
              <input
                type="file"
                className="w-full border-gray-300 p-2 rounded-md"
              />
              <p className="text-sm text-gray-500 mt-1">
                Upload employee documents for HR purposes.
              </p>
            </div>
          </div>
        </div>

        {/* Add New HR Section */}
        <div className="bg-white p-6 rounded-lg shadow-md">
          <h2 className="text-xl font-semibold mb-4">Add New HR</h2>
          <div className="space-y-4">
            {/* Email Input */}
            <div>
              <label className="block font-medium mb-2">Email (Gmail)</label>
              <input
                type="email"
                placeholder="Enter Gmail"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className={`w-full border-gray-300 p-2 rounded-md ${
                  emailError ? "border-red-500" : ""
                }`}
                disabled={isOtpSent || isOtpVerified}
              />
              {emailError && (
                <p className="text-red-500 text-sm mt-1">{emailError}</p>
              )}
            </div>

            {/* OTP Input */}
            {isOtpSent && !isOtpVerified && (
              <div>
                <label className="block font-medium mb-2">Enter OTP</label>
                <input
                  type="text"
                  placeholder="Enter OTP"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  className="w-full border-gray-300 p-2 rounded-md"
                />
                <button
                  onClick={verifyOtp}
                  className="mt-2 w-full bg-blue-500 text-white p-2 rounded-md"
                >
                  Verify OTP
                </button>
              </div>
            )}

            {/* Password Input (shown after OTP is verified) */}
            {isOtpVerified && (
              <div>
                <label className="block font-medium mb-2">Password</label>
                <input
                  type="password"
                  placeholder="Enter password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full border-gray-300 p-2 rounded-md"
                />
              </div>
            )}

            {/* Send OTP or Submit Form */}
            {!isOtpSent && (
              <button
                onClick={sendOtp}
                className="w-full bg-green-500 text-white p-2 rounded-md"
              >
                Send OTP
              </button>
            )}

            {isOtpVerified && (
              <button
                onClick={addNewHR}
                className="w-full bg-blue-500 text-white p-2 rounded-md"
              >
                Add HR
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
